import { UserPlus } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';
import env from 'env';

const SharefileAccessAlert = () => {
  return (
    <Alert className="bg-accent shadow-sm p-6 items-center has-[>svg]:grid-cols-[--spacing(6)_1fr] [&>svg]:size-6">
      <UserPlus className="self-start" />
      <AlertDescription>
        <p className="text-card-foreground text-sm">
          Additional users may have access to the Sharefile folder, but they won&apos;t appear here. To add team
          members, contact us at{' '}
          <a href={`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`} className="underline">
            service@codekeeper.co
          </a>
        </p>
      </AlertDescription>
    </Alert>
  );
};

export default SharefileAccessAlert;
